import React from 'react';
import { ListItemText, MenuItem, ListSubheader } from '@material-ui/core';
import { Check as CheckIcon } from '@material-ui/icons';
import Selector from './selector';

const Filtros = (props) => {
  const {
    show,
    subFiltrosArticulos,
    subfiltrosSeleccionados,
    onSelectionChange,
    onFilter,
  } = props;

  const articuloFiltros = React.useMemo(() => subFiltrosArticulos.filter((x) => x.tipo === 'ARTICULO_FILTRO'), [JSON.stringify(subFiltrosArticulos)]);
  const subrubros = React.useMemo(() => subFiltrosArticulos.filter((x) => x.tipo === 'SUBRUBRO'), [JSON.stringify(subFiltrosArticulos)]);

  const renderValue = (selected) => {
    if (selected.length === 0) {
      return 'Ninguno';
    }
    else if (selected.length > 1) {
      return selected.length + ' seleccionados';
    }

    const filterSelected = subFiltrosArticulos.find((x) => x.valor === selected[0]);
    return filterSelected ? filterSelected.descripcion : selected.join(', ');
  }

  const renderSubHeader = (title) => <ListSubheader style={{ position: 'relative', color: '#0C3653' }}>{title}</ListSubheader>;

  const renderOption = (option) => (
    <MenuItem key={option.valor} value={option.valor} className='itemSeleccion'>
      <ListItemText primary={option.descripcion} />
      { subfiltrosSeleccionados.includes(option.valor) && <CheckIcon style={{ color: '#0C3653' }} /> }
    </MenuItem>
  );
  
  if (!show || (articuloFiltros.length === 0 && subrubros.length === 0)) return null;
  return (
    <Selector
      multiple
      displayEmpty
      placeholder="Filtrar Por"
      value={subfiltrosSeleccionados}
      onChange={({ target }) => onSelectionChange(target.value)}
      onClose={onFilter}
      renderValue={renderValue}
    >
      { articuloFiltros.length > 0 && renderSubHeader('CARACTERÍSTICAS') }
      { articuloFiltros.map((x) => renderOption(x)) }

      { subrubros.length > 0 && renderSubHeader('SUB CATEGORÍAS') }
      { subrubros.map((x) => renderOption(x)) }
    </Selector>
  );
}


export default Filtros;
